<script>
import quit from "@/common/quit";
import cloneDeep from "lodash/cloneDeep";
import intersection from "lodash/intersection";

const packageJSON = require("root/package.json");

export default {
  data() {
    const userId = this.$cookie.get("id");
    const stationId = this.$cookie.get("stationId");
    const hadDirector = this.$cookie.get("hadDirector");
    let edicalEstablishmentShowRoles = [];
    if (this.$cookie.get("stationDirector") == "true") {
      edicalEstablishmentShowRoles = [
        "ROLE_AGENT_OPTOMETRIST",
        "ROLE_DOCTOR",
        "ROLE_STATION_MANAGER"
      ];
    }
    let showInstitutionsList = [];

    if (hadDirector == "true") {
      showInstitutionsList = ["ROLE_AGENT_OPTOMETRIST", "ROLE_STATION_MANAGER"];
    }
    console.log(">>>>>", hadDirector, showInstitutionsList);
    return {
      version: packageJSON.version,
      showQuitConfirm: false,
      showAbout: false,
      navBtnSource1: [
        {
          iconGray: require("@/assets/statistics_overview_gray.svg"),
          iconColor: require("@/assets/statistics_overview.svg"),
          name: "统计概览",
          active: false,
          action() {
            // this.showChildren = !this.showChildren
          },
          children: [
            // {
            //   name: "大区统计图",
            //   //   path: "/index/gamelist/SAME_TIME_BINOCULAR_VISION_TRAINING",
            //   active: false,
            //   showControl: ["ROLE_SUPER_ADMIN"]
            // },
            {
              name: "区域统计图",
              path: "/index/StatisticsAgent",
              active: false,
              showControl: ["ROLE_AGENT"]
            },
            {
              name: "区域统计图",
              path: "/index/StatisticsManagerRange",
              active: false,
              showControl: ["ROLE_REGION_MANAGER", "ROLE_SUPER_ADMIN"]
            },
            {
              name: "代理商统计图",
              path: "/index/StatisticsManagerAgent",
              active: false,
              showControl: ["ROLE_REGION_MANAGER", "ROLE_SUPER_ADMIN"]
            }
          ],
          showChildren: true,
          showControl: ["ROLE_AGENT", "ROLE_REGION_MANAGER", "ROLE_SUPER_ADMIN"]
        },
        {
          iconGray: require("@/assets/nav_userinfo.svg"),
          iconColor: require("@/assets/nav_acount.svg"),
          name: "账户管理",
          path: "/index/acountList/1/账号/-1",
          active: false,
          showControl: ["ROLE_ADMIN", "ROLE_COMPLIANCE"]
        },
        {
          iconGray: require("@/assets/nav_sjjq.svg"),
          iconColor: require("@/assets/nav_bg.svg"),
          name: "训练背景配置",
          path: "/index/bgConfig",
          active: false,
          showControl: ["ROLE_ADMIN", "ROLE_COMPLIANCE"]
        },
        {
          iconGray: require("@/assets/StimulusModeGray.png"),
          iconColor: require("@/assets/StimulusModeBlue.png"),
          name: "刺激模式配置",
          path: "/index/stimulusMode",
          active: false,
          showControl: ["ROLE_ADMIN"]
        },
        {
          iconGray: require("@/assets/stimulusConfigGray.png"),
          iconColor: require("@/assets/stimulusConfigBlue.png"),
          name: "刺激参数配置",
          path: "/index/stimulusConfig",
          active: false,
          showControl: ["ROLE_ADMIN"]
        },
        {
          iconGray: require("@/assets/stimulusGamesGray.png"),
          iconColor: require("@/assets/stimulusGamesBlue.png"),
          name: "游戏刺激参数配置",
          path: "/index/stimulusGames",
          active: false,
          showControl: ["ROLE_ADMIN"]
        },
        {
          iconGray: require("@/assets/log_gray.svg"),
          iconColor: require("@/assets/log_blue.svg"),
          name: "操作日志",
          path: "/index/trainLogs",
          active: false,
          showControl: ["ROLE_COMPLIANCE"]
        },
        {
          iconGray: require("@/assets/version_icon_gray.png"),
          iconColor: require("@/assets/version_icon_blue.png"),
          name: "训练端版本",
          path: "/index/visionClientVersion",
          active: false,
          showControl: ["ROLE_ADMIN"]
        },
        {
          iconGray: require("@/assets/train_weight_gray.png"),
          iconColor: require("@/assets/train_weight_blue.png"),
          name: "训练权重",
          path: "/index/trainWeight",
          active: false,
          showControl: ["ROLE_ADMIN"]
        }
      ],
      navBtnSource2: [
        {
          iconGray: require("@/assets/management_icon_gray.svg"),
          iconColor: require("@/assets/management_icon_blue.svg"),
          name: "管理",
          active: false,
          action() {
            // this.showChildren = !this.showChildren;
          },
          children: [
            {
              name: "代理商",
              path: "/index/agentManage",
              active: false,
              showControl: ["ROLE_REGION_MANAGER", "ROLE_SUPER_ADMIN"]
            },{
              name: "分销商",
              path: "/index/agentManage",
              active: false,
              showControl: ["ROLE_AGENT_MANAGER"]
            },
            {
              name: "大区管理",
              path: "/index/rangeManagement",
              active: false,
              showControl: ["ROLE_SUPER_ADMIN"]
            },
            {
              name: "集团账号",
              path: "/index/groupAccounts",
              active: false,
              showControl: ["ROLE_SUPER_ADMIN"]
            },
            {
              name: "账号管理",
              path: "/index/agencyAccounts",
              active: false,
              showControl: ["ROLE_AGENT"]
            },
            {
              name: "医疗机构",
              path: "/index/medicalEstablishment",
              active: false,
              showControl: [
                "ROLE_SUPER_ADMIN",
                "ROLE_REGION_MANAGER",
                "ROLE_AGENT"
              ]
            },
            {
              name: "医疗机构",
              path: `/index/medicalEstablishment/organizationDetail/${stationId}`,
              active: false,
              showControl: edicalEstablishmentShowRoles
            },
            {
              name: "机构业绩",
              path: `/index/institutionsList`,
              active: false,
              showControl: showInstitutionsList
            },
            {
              name: "授权管理",
              path: "/index/impowerManagement",
              active: false,
              showControl: ["ROLE_REGION_MANAGER"]
            },
            {
              name: "促销申请",
              path: "/index/salesPromotion",
              active: false,
              showControl: ["ROLE_AGENT", "ROLE_AGENT_MANAGER", "ROLE_REGION_MANAGER"]
            },
            {
              name: "视觉训练师", 
              path: "/index/visionManagement",
              active: false,
              showControl: ["ROLE_SUPER_ADMIN"]
            },
            {
              name: "训练跟踪",
              path: "/index/visionTrainTrack",
              active: false,
              showControl: [
                "ROLE_AGENT_OPTOMETRIST",
                "ROLE_STATION_MANAGER"
                // "ROLE_DOCTOR"
              ]
            },
            {
              name: "患者管理",
              path: "/index/patientManagement",
              active: false,
              showControl: [
                "ROLE_AGENT_OPTOMETRIST",
                "ROLE_DOCTOR",
                "ROLE_STATION_MANAGER"
              ]
            },
            {
              name: "人员业绩",
              path: "/index/salesManagement",
              active: false,
              showControl: ["ROLE_AGENT", "ROLE_AGENT_FINANCIAL"]
            },
            {
              name: "机构业绩",
              path: "/index/institutionsList",
              active: false,
              showControl: [
                "ROLE_REGION_MANAGER",
                "ROLE_AGENT",
                "ROLE_AGENT_FINANCIAL",
                "ROLE_SUPER_ADMIN",
              ]
            },
            {
              name: "机构业绩New",
              path: "/index/stationStatistics",
              active: false,
              showControl: [
                "ROLE_REGION_MANAGER",
                "ROLE_AGENT",
                "ROLE_AGENT_FINANCIAL",
                "ROLE_SUPER_ADMIN",
              ]
            },
            {
              name: "退款管理",
              path: "/index/refund",
              active: false,
              showControl: [
                "ROLE_AGENT",
                "ROLE_REGION_MANAGER",
                "ROLE_SUPER_ADMIN",
                "ROLE_AGENT_FINANCIAL"
              ]
            },
            {
              name: "采购历史",
              path: "/index/agentPurchaseHistory",
              active: false,
              showControl: ["ROLE_AGENT", "ROLE_AGENT_FINANCIAL"]
            },
            {
              name: "我的业绩（疗程）",
              path: `/index/salesManagement/salesManagementDetail/${userId}`,
              active: false,
              showControl: ["ROLE_AGENT_OPTOMETRIST", "ROLE_STATION_MANAGER"]
            },
            {
              name: "我的业绩（单次）",
              path: `/index/salesManagement/gameSales/${userId}`,
              active: false,
              showControl: ["ROLE_AGENT_OPTOMETRIST", "ROLE_STATION_MANAGER"]
            }
          ],
          showChildren: true,
          showControl: [
            "ROLE_AGENT_OPTOMETRIST",
            "ROLE_SUPER_ADMIN",
            "ROLE_REGION_MANAGER",
            "ROLE_AGENT",
            "ROLE_DOCTOR",
            "ROLE_AGENT_FINANCIAL",
            "ROLE_STATION_MANAGER"
          ]
        },
        {
          iconGray: require("@/assets/vision_track_gray.png"),
          iconColor: require("@/assets/vision_track_blue.png"),
          name: "训练跟踪",
          path: "/index/visionTrainTrack",
          active: false,
          showControl: ["ROLE_GROUP_OPTOMETRIST"]
        },
        {
          iconGray: require("@/assets/gameReplayAnalysis_gray.png"),
          iconColor: require("@/assets/gameReplayAnalysis_blue.png"),
          name: "训练分析",
          path: "/index/gameReplayAnalysis",
          active: false,
          showControl: ["ROLE_GROUP_OPTOMETRIST"]
        },
        {
          iconGray: require("@/assets/patient_management_gray.png"),
          iconColor: require("@/assets/patient_management_blue.png"),
          name: "患者管理",
          path: "/index/patientManagement",
          active: false,
          showControl: ["ROLE_GROUP_OPTOMETRIST"]
        },
        {
          iconGray: require("@/assets/statistics_icon_gray.png"),
          iconColor: require("@/assets/statistics_icon_blue.png"),
          name: "训练统计",
          path: "/index/StatisticsGroupOptometrist",
          active: false,
          showControl: ["ROLE_GROUP_OPTOMETRIST"]
        },

        {
          iconGray: require("@/assets/version_icon_gray.png"),
          iconColor: require("@/assets/version_icon_blue.png"),
          name: "训练端版本",
          path: "/index/visionClientVersion",
          active: false,
          showControl: [
            "ROLE_AGENT_OPTOMETRIST",
            "ROLE_GROUP_OPTOMETRIST",
            "ROLE_SUPER_ADMIN",
            "ROLE_REGION_MANAGER",
            "ROLE_COMPLIANCE",
            "ROLE_AGENT",
            "ROLE_DOCTOR",
            "ROLE_AGENT_FINANCIAL",
            "ROLE_STATION_MANAGER"
          ]
        },
        {
          iconGray: require("@/assets/gameIntroduce_gray.png"),
          iconColor: require("@/assets/gameIntroduce_blue.png"),
          name: "训练简介",
          path: "/index/gameIntroduce",
          active: false,
          showControl: [
            "ROLE_AGENT_OPTOMETRIST",
            "ROLE_GROUP_OPTOMETRIST",
            "ROLE_DOCTOR",
            "ROLE_STATION_MANAGER"
          ]
        }
      ],
      navBtnSource3: [
        {
          iconGray: require("@/assets/user_info_gray.svg"),
          iconColor: require("@/assets/user_info_blue.svg"),
          name: "用户信息",
          path: "/index/userinfo",
          action: () => {
            // this.showAbout = true;
          },
          active: false,
          showControl: [
            "ROLE_AGENT_OPTOMETRIST",
            "ROLE_GROUP_OPTOMETRIST",
            "ROLE_SUPER_ADMIN",
            "ROLE_REGION_MANAGER",
            "ROLE_ADMIN",
            "ROLE_COMPLIANCE",
            "ROLE_AGENT",
            "ROLE_DOCTOR",
            "ROLE_AGENT_FINANCIAL",
            "ROLE_STATION_MANAGER"
          ]
        },
        {
          iconGray: require("@/assets/system_log_gray.svg"),
          iconColor: require("@/assets/system_log_blue.svg"),
          name: "系统日志",
          path: "/index/systemLog",
          active: false,
          showControl: [
            "ROLE_AGENT_OPTOMETRIST",
            "ROLE_GROUP_OPTOMETRIST",
            "ROLE_SUPER_ADMIN",
            "ROLE_REGION_MANAGER",
            "ROLE_ADMIN",
            "ROLE_COMPLIANCE",
            "ROLE_AGENT",
            "ROLE_DOCTOR",
            "ROLE_AGENT_FINANCIAL",
            "ROLE_STATION_MANAGER"
          ]
        },

        {
          iconGray: require("@/assets/about.svg"),
          iconColor: require("@/assets/nav_about.svg"),
          name: "关于软件",
          action: () => {
            this.showAbout = true;
          },
          active: false,
          showControl: [
            "ROLE_AGENT_OPTOMETRIST",
            "ROLE_GROUP_OPTOMETRIST",
            "ROLE_SUPER_ADMIN",
            "ROLE_REGION_MANAGER",
            "ROLE_ADMIN",
            "ROLE_COMPLIANCE",
            "ROLE_AGENT",
            "ROLE_DOCTOR",
            "ROLE_AGENT_FINANCIAL",
            "ROLE_STATION_MANAGER"
          ]
        },
        {
          iconGray: require("@/assets/quit.svg"),
          iconColor: require("@/assets/nav_quit.svg"),
          name: "退出当前帐号",
          action: () => {
            this.showQuitConfirm = true;
          },
          active: false,
          showControl: [
            "ROLE_AGENT_OPTOMETRIST",
            "ROLE_GROUP_OPTOMETRIST",
            "ROLE_SUPER_ADMIN",
            "ROLE_REGION_MANAGER",
            "ROLE_ADMIN",
            "ROLE_COMPLIANCE",
            "ROLE_AGENT",
            "ROLE_DOCTOR",
            "ROLE_AGENT_FINANCIAL",
            "ROLE_STATION_MANAGER"
          ]
        }
      ]
    };
  },
  created() {
    //刷新时保留图片蓝色状态
    const RoutePath = this.$route.fullPath;

    // console.log("-0-0-", RoutePath);
    const roles = localStorage.getItem("roles").split(",") || [];
    let tempNavBtnSource1 = [];
    this.navBtnSource1.forEach(o => {
      let temp = cloneDeep(o);
      if (intersection(roles, o.showControl).length > 0) {
        if (o.children) {
          temp.children = o.children.filter(
            item => intersection(roles, item.showControl).length > 0
          );
          if (
            temp.children.filter(item => RoutePath.indexOf(item.path) > -1)
              .length > 0
          ) {
            temp.showChildren = true;
          }
          tempNavBtnSource1.push(temp);
        } else {
          tempNavBtnSource1.push(temp);
        }
      }
    });

    let tempNavBtnSource2 = [];
    this.navBtnSource2.forEach(o => {
      // console.log("-0-0-", o);
      let temp = cloneDeep(o);
      if (intersection(roles, o.showControl).length > 0) {
        if (o.children) {
          temp.children = o.children.filter(
            item => intersection(roles, item.showControl).length > 0
          );
          if (
            temp.children.filter(item => RoutePath.indexOf(item.path) > -1)
              .length > 0
          ) {
            temp.showChildren = true;
          }
          tempNavBtnSource2.push(temp);
        } else {
          tempNavBtnSource2.push(temp);
        }
      }
    });
    tempNavBtnSource1.map(o => {
      if (
        o.children &&
        o.children.filter(item => RoutePath.indexOf(item.path) > -1).length > 0
      ) {
        o.showChildren = true;
      }
      return o;
    });
    tempNavBtnSource2.map(o => {
      if (
        o.children &&
        o.children.filter(item => RoutePath.indexOf(item.path) > -1).length > 0
      ) {
        o.showChildren = true;
      }
      return o;
    });
    if (roles.indexOf("ROLE_AGENT_OPTOMETRIST_DEMO") > -1) {
      tempNavBtnSource2.map(o => {
        if (o.children) {
          let children = cloneDeep(o.children);
          o.children = children.filter(item => item.name !== "患者管理");
        }
        return o;
      });
    }
    this.navBtnSource1 = tempNavBtnSource1;
    this.navBtnSource2 = tempNavBtnSource2;
    // if (this.$route.fullPath === "/index/bgConfig") {
    //   this.navBtnSource1[0].active = false;
    //   this.navBtnSource1[1].active = true;
    // }
    //登陆时默认第一项图片为蓝
    // else {
    //   this.navBtnSource1[0].active = true;
    // }
    // let roles = localStorage.getItem("roles")
  },
  methods: {
    quit() {
      sessionStorage.clear();
      quit();
    },
    topNavClicked(val) {
      this.navBtnSource2.forEach((item, index) => {
        item.active = false;
        if (item.children && item.children.length > 0) {
          // item.showChildren = false
          item.children.forEach(o => (o.active = false));
        }
      });
      this.navBtnSource1.forEach((item, index) => {
        item.active = false;
        if (index !== val && item.children && item.children.length > 0) {
          // item.showChildren = false
          item.children.forEach(o => (o.active = false));
        }
      });
      this.navBtnSource1[val].active = true;
    },
    modleNavClicked(val) {
      this.navBtnSource2.forEach((item, index) => {
        item.active = false;
        if (index !== val && item.children && item.children.length > 0) {
          // item.showChildren = false
          item.children.forEach(o => (o.active = false));
        }
      });
      this.navBtnSource1.forEach((item, index) => {
        item.active = false;
        if (item.children && item.children.length > 0) {
          // item.showChildren = false
          item.children.forEach(o => (o.active = false));
        }
      });
      this.navBtnSource2[val].active = true;
    },

    BottomNavClicked(val) {
      this.navBtnSource2.forEach((item, index) => {
        item.active = false;
        if (item.children && item.children.length > 0) {
          item.children.forEach(o => (o.active = false));
        }
      });
      this.navBtnSource1.forEach((item, index) => {
        item.active = false;
        if (item.children && item.children.length > 0) {
          item.children.forEach(o => (o.active = false));
        }
      });
      this.navBtnSource3[val].active = true;
    },
    clickChildren(path) {
      this.navBtnSource2.forEach((item, index) => {
        item.active = false;
        if (item.children && item.children.length > 0) {
          item.children.forEach(o => {
            if (o.path !== path) {
              o.active = false;
            } else {
              o.active = true;
            }
          });
        }
      });
      this.navBtnSource1.forEach((item, index) => {
        item.active = false;
        if (item.children && item.children.length > 0) {
          item.children.forEach(o => {
            if (o.path !== path) {
              o.active = false;
            } else {
              o.active = true;
            }
          });
        }
      });
    }
  }
};
</script>

<template>
  <div class="TheNav">
    <About fixed v-if="showAbout" :version="version" @close="showAbout = false" platform="后台管理" />
    <Dialog
      v-if="showQuitConfirm"
      title="确定退出当前账号？"
      @confirm="quit"
      simple
      @close="showQuitConfirm = false"
    />
    <AdmNavCell
      v-for="(info,index) in navBtnSource1"
      :key="info.name"
      :ChildrIcon="true"
      @topNavClicked="topNavClicked"
      @clickChildren="clickChildren"
      :info="info"
      :index="index"
      :id="info.id"
    />
    <div v-if="navBtnSource1.length > 0" class="line"></div>
    <AdmNavCell
      v-for="(info,index) in navBtnSource2"
      :key="info.name"
      :ChildrIcon="true"
      :info="info"
      :index="index"
      @modleNavClicked="modleNavClicked"
      @clickChildren="clickChildren"
      :id="info.id"
    />
    <div v-if="navBtnSource2.length > 0" class="line"></div>
    <AdmNavCell
      v-for="(info,index) in navBtnSource3"
      :key="info.name"
      :ChildrIcon="true"
      :info="info"
      :index="index"
      @modleNavClicked="BottomNavClicked"
      @clickChildren="clickChildren"
      :id="info.id"
    />
  </div>
</template>ƒ


<style lang="scss" scoped>
.TheNav {
  background-color: #fff;
  width: 200px;
  flex-shrink: 0;
  box-sizing: border-box;
  border-right: 1px solid #e4e8eb;
  padding-top: 36px;
  overflow-y: scroll;
  .line {
    margin-top: 16px;
    margin-bottom: 10px;
    height: 1px;
    margin-left: 20px;
    margin-right: 20px;
    background-color: #e4e8eb;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/index/TheNav.vue